import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';

export const useTitleHistory = (
  source: string,
  identifier: { amazonasin?: string; fiction_id?: string; work_id?: string; author_id?: string },
  enabled: boolean
) => {
  const {
    book: { getTitleHistory }
  } = useServices();

  const identifierValue =
    identifier.amazonasin ?? identifier.fiction_id ?? identifier.work_id ?? identifier.author_id;

  const res = useQuery(
    ['get-title-history', source, identifierValue],
    () => getTitleHistory(source, identifier),
    {
      enabled: enabled && Boolean(identifierValue)
    }
  );

  return {
    data: res.data,
    isError: res.isError,
    isLoading: res.isLoading,
    isFetching: res.isFetching
  };
};